import { followingSidebar } from '../../utils/sidebar.utils.js';

const desktopBreakpoint = 881;
const initializedSections = new WeakSet();

const initArticleSections = (scope = document) => {
  const sections = scope.matches?.('.article-sec')
    ? [scope]
    : scope.querySelectorAll('.article-sec');

  sections.forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    const contentSticky = section.querySelector('.article-sec__wrap');
    const sidebar = section.querySelector('.article-sec__aside');
    const relatedArticles = section.querySelector('.article-sec__related');
    const mobileRelatedArticles = section.querySelector('.article-sec__related-mobile');
    const articleMedia = section.querySelector('.article-sec__media');

    if (
      !contentSticky ||
      !sidebar ||
      !relatedArticles ||
      !mobileRelatedArticles ||
      !articleMedia
    ) {
      return;
    }

    const relatedPlaceholder = document.createComment('article-related-articles-placeholder');
    const mediaPlaceholder = document.createComment('article-media-placeholder');
    const originalRelatedParent = relatedArticles.parentNode;
    const originalMediaParent = articleMedia.parentNode;

    if (!originalRelatedParent || !originalMediaParent) {
      return;
    }

    originalRelatedParent.insertBefore(relatedPlaceholder, relatedArticles);
    originalMediaParent.insertBefore(mediaPlaceholder, articleMedia);

    let sidebarController = null;
    let frameId = null;

    const syncLayout = () => {
      frameId = null;

      if (window.innerWidth >= desktopBreakpoint) {
        if (relatedArticles.parentNode !== originalRelatedParent) {
          originalRelatedParent.insertBefore(relatedArticles, relatedPlaceholder.nextSibling);
        }

        if (articleMedia.parentNode !== originalMediaParent) {
          originalMediaParent.insertBefore(articleMedia, mediaPlaceholder.nextSibling);
        }

        if (!sidebarController) {
          sidebarController = followingSidebar({
            sidebar,
            contentSticky,
              gap: 80,
            bottomGap: 40,
          });
        }

        sidebarController.update();
        return;
      }

      sidebarController?.destroy();
      sidebarController = null;

      if (relatedArticles.parentNode !== mobileRelatedArticles) {
        mobileRelatedArticles.append(relatedArticles);
      }

      if (
        articleMedia.parentNode !== mobileRelatedArticles.parentNode ||
        articleMedia.previousElementSibling !== mobileRelatedArticles
      ) {
        mobileRelatedArticles.after(articleMedia);
      }
    };

    const scheduleSync = () => {
      if (frameId !== null) {
        return;
      }

      frameId = window.requestAnimationFrame(syncLayout);
    };

    window.addEventListener('resize', scheduleSync, { passive: true });
    syncLayout();
    initializedSections.add(section);
  });
};

initArticleSections();
window.initArticleSections = initArticleSections;
